import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import type { Ad } from '@barter/shared';
import { getFavoriteAds } from '../../db/database';
import { EmptyState } from '../../components/EmptyState/EmptyState';
import { AdCard } from '../../components/AdCard/AdCard';

// Избранное живёт только на устройстве (Dexie) — серверная таблица favorites
// больше не используется; снапшот подтягивает сами объявления.

export function FavoritesPage() {
  const { t } = useTranslation();
  const [ads, setAds] = useState<Ad[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const local = await getFavoriteAds();
        if (!cancelled) setAds(local);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <div className="loading-state">{t('common.loading')}</div>;

  if (ads.length === 0) {
    return <EmptyState icon="❤️" text={t('favorites.noFavorites')} hint={t('favorites.hint')} />;
  }

  return (
    <div>
      <h2 className="section-title">{t('favorites.title')}</h2>
      <div className="offer-list">
        {ads.map((ad) => (
          <AdCard key={ad.id} ad={ad} />
        ))}
      </div>
    </div>
  );
}
